<template>
  <fin-small-card
    v-on="$listeners.click ? {click: (e) => $emit('click', e)} : {}"
    :card-options="cardOptions"
    :contentOnly="contentOnly"
    :inactive="inactiveItem"
    :mode="titleFirst ? 'titleFirst' : null">

    <template #chart>
      <fin-data-loader overlay :resolver="resolver" :data-adapter="adapter" @input="change" small-loader>
        <template #content>
          <fin-chart2 :options="chartData"/>
        </template>
      </fin-data-loader>
    </template>

    <template #title>
      {{ title }}
    </template>

    <template #value1 v-if="chartData">
      <v-fade-transition leave-absolute>
          <span :key="`current-${currentValue}`">
           {{ currentValue | currencyRounded(valueSuffix, 2) }}
          </span>
      </v-fade-transition>
      <fin-lexicon-link icon="mdi-minus-circle"
                        to="inaktives-wertpapier"
                        v-if="!performance"/>
    </template>

    <template #value2 v-if="performance">
      <fin-value-change
        :absolute="performance.absolute"
        :percent="hidePercentageChange ? null : performance.percent"
        :valueSuffix="performanceSuffix"
      />
      <div>
        <fin-time-ago
          class="changeDate"
          prependText="Seit"
          :datetime="performance.from"
          full-date
          v-if="performance.from"/>
        <span v-else>-</span>
      </div>
    </template>

    <template v-else #value2>
      <div style="min-height: 38px;"/>
    </template>

    <template #small-chart-actions>
      <slot name="small-chart-actions"/>
    </template>
  </fin-small-card>
</template>

<script>
import HighchartsCore from 'highcharts'
import FinSmallCard from "@/components/pages/myFinHub/common/SmallCard"
import FinChart2 from "@/components/common/Chart2/FinChart2"
import FinValueChange from "@/components/common/Chart2/PerformanceCharts/ValueChange"
import FinDataLoader from "@/components/common/DataLoader"
import FinLexiconLink from "@/components/common/lexicon/LexiconLink"

function getY(point) {
  if (!point) return 0
  //TODO util
  if (Array.isArray(point)) {
    return point.length > 1 ? point[1] : 0
  }
  return point.curr || point.y || 0
}

export default {
  name: "FinSmallPerformanceChart",
  components: {FinDataLoader, FinValueChange, FinChart2, FinSmallCard, FinLexiconLink},
  props: {
    title: {
      type: String
    },
    cardOptions: {
      type: Object
    },
    chartOptions: {
      type: [Object, Function]
    },
    titleFirst: {
      type: Boolean
    },
    contentOnly: {
      type: Boolean
    },
    hidePercentageChange: {
      type: Boolean
    },
    inactiveItem: {
      type: Boolean,
      default: false
    },
  },
  data: () => {
    return {
      performance: null,
      chartData: null
    }
  },
  computed: {
    resolver() {
      return this.chartOptions
    },
    valueSuffix() {
      return this.chartData?.tooltip?.valueSuffix || ''
    },
    performanceSuffix() {
      return this.chartData?.tooltip?.performanceSuffix || this.valueSuffix
    },
    currentValue() {
      return getY(this.performance?.end)
    },
    changeDate() {
      return this.performance?.to ? new Date(this.performance.to) : null
    },
  },
  methods: {
    adapter(val) {
      if (val?.series?.length) {
        val = HighchartsCore.merge({}, val)
        val.series[0].events = {
          performance: (props) => {
            this.performance = props
          }
        }
      }
      return val
    },
    change(val) {
      this.chartData = val
    },
  },
}
</script>

<style lang="scss" scoped>

.changeDate {
  font-family: $body-font-family;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  color: var(--grey-7);
}
</style>
